type CreateClassicAddressProps = {
  street?: string;
  postalCode?: string;
  city?: string;
};

export const createAddress = ({
  street,
  postalCode,
  city,
}: CreateClassicAddressProps) => {
  if (!street && !postalCode && !city) {
    return '';
  }

  let address = street;
  if (address && address.length && (postalCode || city)) {
    address = address + ',';
  }
  address = `${address} ${postalCode} ${city}`;

  return address;
};

export const createAddressHRef = (address: string) =>
  `https://maps.google.com/maps?q=${address}`;
